import script from "./Box.vue?vue&type=script&setup=true&lang=js"
export * from "./Box.vue?vue&type=script&setup=true&lang=js"

import "./Box.vue?vue&type=style&index=0&id=bd08e29a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd08e29a"]])

export default __exports__